import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg'

export default EditIcon
